import { Ref, ref } from 'vue'
import { LocationQueryValue } from 'vue-router'

import { StateField, StateFieldConfig } from '../StateField'

export type TextStateFieldConfig = StateFieldConfig<TextStateField> & {
  type: 'text'
  default?: string
  overrideValue?: Ref<string>

  minLength?: number
  maxLength?: number
  inputType?: 'text' | 'email' | 'password' | 'textarea' | 'number'
  inputPlaceholder?: string
  inputRequired?: boolean
  inputPrefix?: string // Textarea only
  inputSuffix?: string // Textarea only
  inputMaxHeight?: number // Textarea only
  inputMinHeight?: number // Textarea only
}

export class TextStateField extends StateField {
  readonly type = 'text'
  default: string = ''
  value: Ref<string>

  minLength?: number
  maxLength?: number
  inputType?: 'text' | 'email' | 'password' | 'textarea'
  inputPlaceholder?: string
  inputRequired?: boolean
  inputPrefix?: string // Textarea only
  inputSuffix?: string // Textarea only
  inputMaxHeight?: number // Textarea only
  inputMinHeight?: number // Textarea only

  constructor(config: TextStateFieldConfig) {
    super(config)

    this.value = config.overrideValue || ref(config.default || '')
    this.inputType = config.inputType || 'text'
    this.inputPlaceholder = config.inputPlaceholder
    this.minLength = config.minLength
    this.maxLength = config.maxLength
    this.inputRequired = config.inputRequired
    this.inputPrefix = config.inputPrefix
    this.inputSuffix = config.inputSuffix
    this.inputMaxHeight = config.inputMaxHeight
    this.inputMinHeight = config.inputMinHeight
  }

  toRouteValue(): string | undefined {
    if (this.toRouteValueOverride) return this.toRouteValueOverride(this)
    if (this.value.value === this.default) return undefined
    return this.value.value
  }

  pullRouteQueryValue(value: LocationQueryValue | LocationQueryValue[]): void {
    if (this.pullRouteQueryValueOverride)
      return this.pullRouteQueryValueOverride(this, value)

    this.value.value = value?.toString() || this.default || ''
  }

  pullRouteParamValue(value: string | string[]): void {
    if (this.pullRouteParamValueOverride)
      return this.pullRouteParamValueOverride(this, value)

    this.value.value = value?.toString() || this.default || ''
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async toRequestVariable(variation: number): Promise<string> {
    if (this.toRequestVariableOverride)
      return await this.toRequestVariableOverride(this, variation)

    return this.value.value
  }

  resetValue(): void {
    if (this.resetValueOverride) return this.resetValueOverride(this)

    this.value.value = this.default || ''
  }
}
